<template>
  <el-row class="integration-available-grid">
    <el-col v-if="shouldShow('1')" :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
      <ToutBox ref="toutbox" v-bind:customer="customer" v-on:refresh="refresh" v-bind:active="state" />
    </el-col>
    <el-col v-if="shouldShow('2')" :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
      <Bling ref="bling" v-bind:customer="customer" v-on:refresh="refresh" v-bind:active="state" />
    </el-col>
    <el-col v-if="shouldShow('7')" :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
      <Vtex ref="vtex" v-bind:customer="customer" v-on:refresh="refresh" v-bind:active="state" />
    </el-col>
    <el-col v-if="shouldShow('4')" :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
      <NuvemShop ref="nuvemshop" v-bind:customer="customer" v-on:refresh="refresh" v-bind:active="state" />
    </el-col>
    <el-col v-if="shouldShow('11')" :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
      <Dooca ref="dooca" v-bind:customer="customer" v-on:refresh="refresh" v-bind:active="state" />
    </el-col>
    <el-col v-if="shouldShow('3')" :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
      <Intelipost ref="intelipost" v-bind:customer="customer" v-on:refresh="refresh" v-bind:active="state" />
    </el-col>
    <el-col v-if="shouldShow('12')" :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
      <Irroba ref="irroba" v-bind:customer="customer" v-on:refresh="refresh" v-bind:active="state" />
    </el-col>
    <el-col v-if="shouldShow('13')" :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
      <LojaIntegrada ref="lojaintegrada" v-bind:customer="customer" v-on:refresh="refresh" v-bind:active="state" />
    </el-col>
    <el-col v-if="shouldShow('5')" :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
      <Pluggto ref="pluggto" v-bind:customer="customer" v-on:refresh="refresh" v-bind:active="state" />
    </el-col>
    <el-col v-if="shouldShow('6')" :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
      <Tiny ref="tiny" v-bind:customer="customer" v-on:refresh="refresh" v-bind:active="state" />
    </el-col>
    <el-col v-if="shouldShow('14')" :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
      <WooCommerce ref="woocommerce" v-bind:customer="customer" v-on:refresh="refresh" v-bind:active="state" />
    </el-col>
    <el-col v-if="shouldShow('19')" :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
      <Vnda ref="vnda" v-bind:customer="customer" v-on:refresh="refresh" v-bind:active="state" />
    </el-col>
    <el-col v-if="shouldShow('22')" :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
      <BWCommerce ref="bwcommerce" v-bind:customer="customer" v-on:refresh="refresh" v-bind:active="state" />
    </el-col>
    <el-col v-if="shouldShow('23')" :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
      <Wbuy ref="wbuy" v-bind:customer="customer" v-on:refresh="refresh" v-bind:active="state" />
    </el-col>
    <el-col v-if="shouldShow('24')" :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
      <Shopify ref="shopify" v-bind:customer="customer" v-on:refresh="refresh" v-bind:active="state" />
    </el-col>
    <el-col v-if="shouldShow('25')" :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
      <ExternalIntegration ref="vanrooy" type="25" title="Van Rooy" image="/img/integration/logo-vanrooy.jpeg"
        v-bind:customer="customer" v-on:refresh="refresh" v-bind:active="state" />
    </el-col>
    <el-col v-if="shouldShow('26')" :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
      <ExternalIntegration ref="wake" type="26" title="Wake" image="/img/integration/logo-wake.png"
        v-bind:customer="customer" v-on:refresh="refresh" v-bind:active="state" />
    </el-col>
    <el-col v-if="shouldShow('27')" :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
      <ExternalIntegration ref="bravo" type="27" title="Bravo" image="/img/integration/logo-bravo.jpeg"
        v-bind:customer="customer" v-on:refresh="refresh" v-bind:active="state" />
    </el-col>
    <el-col v-if="shouldShow('28')" :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
      <ExternalIntegration ref="binext" type="28" title="Binext" image="/img/integration/logo-binext.jpeg"
        v-bind:customer="customer" v-on:refresh="refresh" v-bind:active="state" />
    </el-col>
  </el-row>
</template>
<script>
import Bling from "../apps/Bling.vue";
import ToutBox from "../apps/ToutBox";
import Vtex from "../apps/Vtex.vue";
import NuvemShop from "../apps/NuvemShop.vue";
import Dooca from "../apps/Dooca.vue";
import Intelipost from "../apps/Intelipost.vue";
import Irroba from "../apps/Irroba.vue";
import LojaIntegrada from "../apps/LojaIntegrada.vue";
import Pluggto from "../apps/Pluggto.vue";
import Tiny from "../apps/Tiny.vue";
import WooCommerce from "../apps/WooCommerce.vue";
import Vnda from '../apps/Vnda.vue';
import BWCommerce from '../apps/BWCommerce.vue';
import Shopify from "../apps/Shopify.vue";
import * as apps from './app.json'
import Wbuy from "../apps/Wbuy.vue";
import ExternalIntegration from "../apps/ExternalIntegration.vue";

export default {
  props: ["customer", "tableData", "state"],
  components: {
    ToutBox,
    Bling,
    Vtex,
    NuvemShop,
    Dooca,
    Intelipost,
    Irroba,
    LojaIntegrada,
    Pluggto,
    Tiny,
    WooCommerce,
    Vnda,
    BWCommerce,
    Wbuy,
    Shopify,
    ExternalIntegration,
  },
  methods: {
    refresh() {
      const vm = this;
      vm.$emit("refresh");
    },
    list() {
      const vm = this;
      setTimeout(() => {
        const list = apps.default;
        for (const app of list) {
          const record = vm.tableData.find(x => x.type === app.type);
          if (vm.$refs[app.ref]) vm.$refs[app.ref].reset();
          if (vm.$refs[app.ref] && record) {
            vm.$refs[app.ref].setConfig(record);
          }
        }
      }, 300)
    },
    normalizeStatus(status) {
      return status === true || status === 1 || status === "1" || status === "S" || status === "true";
    },
    shouldShow(type) {
      const record = this.tableData.find(item => item.type === type);
      const isIntegrated = record ? this.normalizeStatus(record.status) : false;
      return this.state === isIntegrated;
    },
  }
}
</script>
<style>
.integration-available-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
}

@media (max-width: 1400px) {
  .integration-available-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 1100px) {
  .integration-available-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .integration-available-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}

.integration-available-grid::before,
.integration-available-grid::after {
  content: none;
}

.integration-available-grid .el-col {
  float: none;
  display: flex;
  width: 100%;
  max-width: 100%;
}

.integration-available-grid .el-col > div {
  width: 100%;
}
</style>
